<template>
    <div v-if="isDetail">
    </div>
    <!-- Note: 这里必须保证 只有 add-container 一个节点 -->
    <add-container
        v-else
        ref="container"
        :init-item="initBoxProp"
        :item-list="data"
        :all-city-list="allCityList"
        :public-city-ids="publicCityIds"
        :is-required="isRequired"
        :can-delete-condition="canDeleteCondition"
        title="箱规"
    >
        <div
            slot-scope="scope"
            :class="{'existed-ids-disabled': scope.item.existedIds && scope.item.existedIds.length > 0}"
        >
            <xx-form-item
                label="箱规"
                :prop="`cityBoxProps.${scope.$index}.boxProps.boxQuantity`"
                :rules="rules.boxQuantity"
            >
                <el-input-number
                    v-model="scope.item.boxProps.boxQuantity"
                    style="width: 180px"
                    :controls="false"
                />
                <box-example />
            </xx-form-item>
            <div>
                <label class="box-size-label">箱规长宽高(厘米)：</label>
                <div class="box-size-content">
                    <el-row
                        :gutter="10"
                        class="box-size"
                    >
                        <el-col :span="8">
                            <xx-form-item
                                :prop="`cityBoxProps.${scope.$index}.boxProps.boxLength`"
                                :rules="rules.boxLength"
                            >
                                <el-input
                                    v-model="scope.item.boxProps.boxLength"
                                    placeholder="请输入"
                                    type="number"
                                >
                                    <template slot="prepend">
                                        长
                                    </template>
                                </el-input>
                            </xx-form-item>
                        </el-col>
                        <el-col :span="8">
                            <xx-form-item
                                :prop="`cityBoxProps.${scope.$index}.boxProps.boxWidth`"
                                :rules="rules.boxWidth"
                            >
                                <el-input
                                    v-model="scope.item.boxProps.boxWidth"
                                    placeholder="请输入"
                                    type="number"
                                >
                                    <template slot="prepend">
                                        宽
                                    </template>
                                </el-input>
                            </xx-form-item>
                        </el-col>
                        <el-col :span="8">
                            <xx-form-item
                                :prop="`cityBoxProps.${scope.$index}.boxProps.boxHeight`"
                                :rules="rules.boxHeight"
                            >
                                <el-input
                                    v-model="scope.item.boxProps.boxHeight"
                                    placeholder="请输入"
                                    type="number"
                                >
                                    <template slot="prepend">
                                        高
                                    </template>
                                </el-input>
                            </xx-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </add-container>
</template>

<script>
import Rules from '@lsfe/rules';
import AddContainer from './addContainer';
import { initBoxProp } from './config';
import autoFillCityId from './mixins/autoFillCityId';
import boxExample from './boxExample';

const bulkErrMsg = '散装箱规大于0并且小于10000，不能超过3位小数';
const sampleErrMsg = '标品箱规大于0并且小于10000的整数';

export default {
    components: {
        AddContainer,
        boxExample,
    },
    mixins: [autoFillCityId],
    props: {
        isDetail: {
            type: Boolean,
            default: false,
        },
        data: {
            type: Array,
            default: () => [],
        },
        allCityList: {
            type: Array,
            default: () => [],
        },
        publicCityIds: {
            type: Array,
            default: () => [],
        },
        // 是否至少保留一个item，“是”则第一个item没有delete按钮
        isRequired: {
            type: Boolean,
            default: true,
        },
        canDeleteCondition: {
            type: Function,
            default: () => true,
        },
        // 是否散装
        isBulk: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            initBoxProp,
        };
    },
    computed: {
        rules() {
            return {
                boxLength: [
                    Rules.decimalLen({ len: 1 }, '最多一位小数'),
                    Rules.range({
                        min: 0,
                        max: 200,
                        le: false,
                    }, '0< 当前值 <=200'),
                ],
                boxWidth: [
                    Rules.decimalLen({ len: 1 }, '最多一位小数'),
                    Rules.range({
                        min: 0,
                        max: 200,
                        le: false,
                    }, '0< 当前值 <=200'),
                ],
                boxHeight: [
                    Rules.decimalLen({ len: 1 }, '最多一位小数'),
                    Rules.range({
                        min: 0,
                        max: 200,
                        le: false,
                    }, '0< 当前值 <=200'),
                ],
                boxQuantity: this.handleBoxQuantityRules(),
            };
        },
    },
    created() {
    },
    methods: {
        getData() {
            return this.$refs.container.getData();
        },
        handleBoxQuantityRules() {
            const { isBulk } = this;
            const errMsg = isBulk ? bulkErrMsg : sampleErrMsg;
            const digits = isBulk ? 3 : 0;
            return [
                Rules.isRequired(errMsg),
                Rules.decimalLen({ len: digits }, errMsg),
                Rules.range({
                    min: 0,
                    max: 10000,
                    le: false,
                    ge: true,
                }, errMsg),
            ];
        },
    },
};
</script>

<style scoped lang="scss">
.existed-ids-disabled {
    position: relative;
    &::after {
       content: '';
       top: 0;
       right: 0;
       bottom: 0;
       left: 0;
       position: absolute;
       z-index: 2;
       cursor: not-allowed;
   }
}
.box-size {
    display: flex;
}
.box-size-label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #585D66;
    line-height: 33px;
    padding: 0 12px 0 0;
    box-sizing: border-box;
    width: 130px;
}
.box-size-content {
    line-height: 33px;
    position: relative;
    font-size: 14px;
    margin-left: 130px;
}
::v-deep .el-form-item.is-error .el-input__inner, .el-form-item.is-error .el-input__inner:focus, .el-form-item.is-error .el-textarea__inner, .el-form-item.is-error .el-textarea__inner:focus {
    border-color: #EB2F3C !important;
}
</style>
